import { render, staticRenderFns } from "./email-editor.vue?vue&type=template&id=6043b8cc&scoped=true"
import script from "./email-editor.vue?vue&type=script&lang=ts"
export * from "./email-editor.vue?vue&type=script&lang=ts"
import style0 from "./email-editor.vue?vue&type=style&index=0&id=6043b8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6043b8cc",
  null
  
)

export default component.exports